export default __webpack_public_path__ + "static/media/Pcv1AssemblyH.4762e456.png";